import React, { Component } from 'react';
import { Modal, Row, Col, Table} from 'react-bootstrap';
import _ from 'lodash';

export default class ViewWebForm extends Component { 
  constructor(props){
    super(props)
    this.state={
      toggle:true,
      toggleA:false,
      
    }
  }
    render(){
      const{data, Regiontitle} = this.props;
      let UI= _.map(data.objects, (val, index) =>{
        return( <tr >         
        <td md={1}>{index+1}</td>
        <td>{val.label}</td>
        </tr>)      
     })
      let n = UI.length
      let firstObj = UI
      let secondObj =[]
      if(n>=10){
      firstObj = _.slice(UI, 0, n/2+1)
      secondObj = _.slice(UI, n/2+1, n) }
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl "
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered>  
       <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              <span>{"View Form --"+data.title+"--"+Regiontitle}</span></Modal.Title>   
      </Modal.Header>
      <Modal.Body>
        <div>
        <Row><Col>        
        <Table responsive>
            <thead><th></th><th>WEB FORM FIELD NAME</th></thead>
            <tbody>
              {firstObj}
            </tbody>
          </Table>  
          </Col>
          <Col>
         { (n>=10) ?
          <Table responsive>
            <thead><th>#</th><th>WEB FORM FIELD NAME</th></thead>
            <tbody>
              {secondObj}
            </tbody>
          </Table>      : null}
          </Col>
          </Row></div>
      </Modal.Body>      
      </Modal>
      )
    }
    
 
}

  